import 'rsuite/dist/styles/rsuite-default.css'

import './calendar-selection-dropdown.scss'

import React, { useCallback, useMemo, useState } from 'react'

import moment from 'moment'
import { DateRangePicker } from 'rsuite'

const DATE_FORMATS = {
  '{dd}/{MM}/{yyyy}': 'DD/MM/YYYY',
  '{dd}/{yyyy}/{MM}': 'DD/YYYY/MM',
  '{MM}/{dd}/{yyyy}': 'MM/DD/YYYY',
  '{MM}/{yyyy}/{dd}': 'MM/YYYY/DD',
  '{yyyy}/{dd}/{MM}': 'YYYY/DD/MM',
  '{yyyy}/{MM}/{dd}': 'YYYY/MM/DD',
}

const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY'

const PICKER_LOCALE = {
  sunday: 'Su',
  monday: 'Mo',
  tuesday: 'Tu',
  wednesday: 'We',
  thursday: 'Th',
  friday: 'Fr',
  saturday: 'Sa',
  ok: 'Apply',
  today: 'Today',
  yesterday: 'Yesterday',
  last7Days: 'Last 7 Days',
  formattedMonthPattern: 'MMM YYYY',
  formattedDayPattern: 'DD MMM YYYY',
}

const getStartDateTime = (date) =>
  `${moment(date).format('YYYY-MM-DD')}T00:00:00`

const getEndDateTime = (date) => `${moment(date).format('YYYY-MM-DD')}T23:59:00`

const getDefaultValue = () => {
  const startDate = moment().subtract(7, 'days').startOf('day').toDate()
  const endDate = moment().endOf('day').toDate()

  return [startDate, endDate]
}

const CalenderSelectionDropdown = (props) => {
  const { caption, className, dateFormat, id, parentCallback } = props

  const [value, setValue] = useState(getDefaultValue)

  const pickerDateFormat = useMemo(
    () => DATE_FORMATS[dateFormat] || DEFAULT_DATE_FORMAT,
    [dateFormat],
  )

  const ranges = useMemo(
    () => [
      {
        label: 'Today',
        value: [
          moment().startOf('day').toDate(),
          moment().endOf('day').toDate(),
        ],
      },
      {
        label: 'This Month',
        value: [
          moment().startOf('month').toDate(),
          moment().endOf('month').toDate(),
        ],
      },
      {
        label: 'Previous Month',
        value: [
          moment().subtract(1, 'month').startOf('month').toDate(),
          moment().subtract(1, 'month').endOf('month').toDate(),
        ],
      },
      {
        label: 'Last 30 Days',
        value: [
          moment().subtract(30, 'days').startOf('day').toDate(),
          moment().subtract(1, 'days').endOf('day').toDate(),
        ],
      },
    ],
    [],
  )

  const onChange = useCallback(
    (event) => {
      const selectedRange = event || []
      const invalidRange =
        selectedRange.length !== 2 ||
        selectedRange.some((date) => !moment(date).isValid())

      if (invalidRange) {
        setValue(selectedRange)
        return
      }

      setValue(selectedRange)

      if (parentCallback) {
        parentCallback(
          getStartDateTime(selectedRange[0]),
          getEndDateTime(selectedRange[1]),
        )
      }
    },
    [parentCallback],
  )

  const renderValue = useCallback(
    (selectedRange, format) =>
      `${moment(selectedRange[0]).format(format)} - ${moment(
        selectedRange[1],
      ).format(format)}`,
    [],
  )

  const showRequiredMessage =
    !value ||
    value.length !== 2 ||
    value.some((date) => !moment(date).isValid())

  return (
    <div id={id} className={className}>
      <div className="dx-fieldset-text">
        <div className="dx-field">
          <div className="dx-field-label">
            <span style={{ color: 'red' }}>* </span>
            <span>{caption}</span>
            {showRequiredMessage ? (
              <span className="required-field">Required</span>
            ) : null}
          </div>
        </div>
      </div>

      <div className="dx-fieldset" id="calendar-splitter-indicator">
        <div className="dx-field">
          <div className="dx-field-value">
            <DateRangePicker
              className="calendar-wrapper"
              value={value}
              onChange={onChange}
              format={pickerDateFormat}
              placeholder={`${pickerDateFormat} - ${pickerDateFormat}`}
              renderValue={renderValue}
              ranges={ranges}
              cleanable={false}
              locale={PICKER_LOCALE}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CalenderSelectionDropdown
